import $ from "jquery";

let vids = document.querySelectorAll(".c-page-slider__slide video"),
  i;
for (i = 0; i < vids.length; ++i) {
  vids[i].play();
}

$(function () {
  function showCurrentSlideGif() {
    var src = $(".slick-current img").attr("data-gif-src");
    if (src) {
      $(".slick-current .c-page-slider__slide-inner .image").html(
        `<video autoplay muted loop><source src=${src} type="video/mp4"></video>`
      );
    }
    var allVids = document.querySelectorAll(
        ".c-page-slider__slides .slick-slide video"
      ),
      i;
    for (i = 0; i < allVids.length; ++i) {
      allVids[i].pause();
    }
    var currentVid = document.querySelectorAll(
        ".c-page-slider__slides .slick-current video"
      ),
      j;
    for (j = 0; j < currentVid.length; ++j) {
      currentVid[j].play();
    }
  }
  $(window).one("scroll", function () {
    showCurrentSlideGif();
  });

  $(".slick-arrow").on("click", function () {
    showCurrentSlideGif();
  });
});
